
import React, { createRef, useEffect } from 'react';
import { Content, DataEmpty, Wrapper } from './styles';
import { useSalesSlip } from 'pages/SalesSlip/useSalesSlip';
import SearchBox from 'components/SearchBox';
import SalesSlipItem from 'pages/SalesSlip/components/SalesSlipItem';
import MessageBox from 'components/MessageBox';

const ClientSalesSlip = ({ cID, cName }) => {
  const { clientID, salesSlipList, termSearch, setTermSearch, isLoading, message, setMessage } = useSalesSlip(cID, cName);

  const refTop = createRef();
  useEffect(() => {
    refTop.current.scrollTo(0, 0);
    return;
  }, [salesSlipList, refTop])

  return (
    <Wrapper>
      <MessageBox message={message} setMessage={setMessage} />
      <SearchBox textHolder={clientID > 5 ? '現場名' : 'お客様名、'} termSearch={termSearch} setTermSearch={setTermSearch} />
      <Content ref={refTop}>
        {salesSlipList?.length > 0 ? (
          salesSlipList.map((item) => {
            return (<SalesSlipItem key={item.SalesSlipID} item={item} />)
          })
        ) : (<DataEmpty>データなし</DataEmpty>)}
      </Content>
    </Wrapper>
  )
}

export default ClientSalesSlip;